import actionTypes from './action.types';

// eslint-disable-next-line import/prefer-default-export
const setStoreSettings = (settings) => ({
  type: actionTypes.STORE_SET_SETTINGS,
  settings
});

export default setStoreSettings;
